module.exports = __webpack_public_path__ + "img/saojoseriopreto.62db4c91.jpg";